'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.banner =
  twentyninetimes.banner ||
  (function () {
    const banner = document.querySelector('.banner');
    const bannerCloseButton = document.querySelector('.banner-close-button');
    const header = document.querySelector('#js-site-header');
    const status = sessionStorage.getItem('bannerClosed');

    // If banner is closed, remove it from the DOM
    if (status === 'true') {
      if (banner) {
        banner.remove();
        header.classList.remove('has-banner');
      }
      // Always return an object with an init method
      return {
        init: function () {},
      };
    }

    if (!status) {
      document.body.classList.add('show-banner');
      header.classList.add('has-banner');
    }

    function scrollHandler() {
      if (window.scrollY > 0) {
        header.classList.remove('has-banner');
      } else {
        header.classList.add('has-banner');
      }
    }

    function init() {
      if (!banner) return;
      // Remove has-banner class from header on scroll
      window.addEventListener('scroll', scrollHandler);
    }

    bannerCloseButton &&
      bannerCloseButton?.addEventListener('click', function (e) {
        e.preventDefault();
        banner?.remove();
        header?.classList.remove('has-banner');
        document.body.classList.remove('show-banner');

        // Set session storage to prevent banner from showing again
        sessionStorage.setItem('bannerClosed', 'true');

        // remove event listener
        window.removeEventListener('scroll', scrollHandler);
      });

    return {
      init: init,
    };
  })();
